import React from 'react';
import styled from 'styled-components';
import { Button, Icon } from '@column/column-ui-kit';
import { useSessionStore } from '~/stores/Session';
import { log } from '~/util';

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Quicklinks: React.FC = () => {
  const currentUser = useSessionStore((state) => state.currentUser);

  const handleClick = () => {
    log({
      name: 'Documentation clicked',
      context: currentUser,
    });

    window.open('https://column.com/docs');
  };

  return (
    <Wrapper>
      <Button size="small" variant="subtle" onClick={handleClick} icon={<Icon.CircleQuestionmark />}>
        Documentation
      </Button>
    </Wrapper>
  );
};
